import { render, staticRenderFns } from "./audienceRegister.vue?vue&type=template&id=cf0d9a66"
import script from "./audienceRegister.vue?vue&type=script&lang=js"
export * from "./audienceRegister.vue?vue&type=script&lang=js"
import style0 from "./audienceRegister.vue?vue&type=style&index=0&id=cf0d9a66&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports